module.exports = __webpack_public_path__ + "img/telefoon-icon.64fd09c5567a5a3551a6a74cf0c735e2.svg";